import React from 'react';
import AgreementCheckTypesPageContent from '../../AgreementCheckTypes/Components/AgreementCheckTypesPageContent';

export default function AgreementCheckTypesPage() {
    return <AgreementCheckTypesPageContent />;
}
